// API service for conversation messages following the sessions pattern
import apiClient from './apiClient';

class MessagesAPI {

  // POST /conversation/messages/
  async createMessage(messageData) {
    return apiClient.makeAuthenticatedRequest('/conversation/messages/', {
      method: 'POST',
      body: JSON.stringify(messageData),
    });
  }

  // GET /conversation/messages/{message_id}
  async getMessageById(messageId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/${encodeURIComponent(messageId)}`, {
      method: 'GET',
    });
  }

  // PUT /conversation/messages/{message_id}
  async updateMessage(messageId, updateData) {
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/${encodeURIComponent(messageId)}`, {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  }

  // DELETE /conversation/messages/{message_id}
  async deleteMessage(messageId) {
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/${encodeURIComponent(messageId)}`, {
      method: 'DELETE',
    });
  }

  // GET /conversation/messages/session/{session_id}?limit=&offset=
  async getMessagesBySession(sessionId, limit = 100, offset = 0) {
    const params = new URLSearchParams({
      limit: String(limit),
      offset: String(offset),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/session/${encodeURIComponent(sessionId)}?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/messages/session/{session_id}/recent?limit=
  async getRecentMessages(sessionId, limit = 50) {
    const params = new URLSearchParams({
      limit: String(limit),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/session/${encodeURIComponent(sessionId)}/recent?${params}`, {
      method: 'GET',
    });
  }

  // GET /conversation/messages/session/{session_id}/role/{role}
  async getMessagesByRole(sessionId, role) {
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/session/${encodeURIComponent(sessionId)}/role/${encodeURIComponent(role)}`, {
      method: 'GET',
    });
  }

  // GET /conversation/messages/session/{session_id}/search?search_term=
  async searchMessages(sessionId, searchTerm) {
    const params = new URLSearchParams({
      search_term: String(searchTerm),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/session/${encodeURIComponent(sessionId)}/search?${params}`, {
      method: 'GET',
    });
  }

  // POST /conversation/messages/{message_id}/stream?content=
  async addMessageStream(messageId, content) {
    const params = new URLSearchParams({
      content: String(content),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/${encodeURIComponent(messageId)}/stream?${params}`, {
      method: 'POST',
    });
  }

  // PUT /conversation/messages/{message_id}/stream/{stream_id}?content=
  async updateMessageStream(messageId, streamId, content) {
    const params = new URLSearchParams({
      content: String(content),
    }).toString();
    return apiClient.makeAuthenticatedRequest(`/conversation/messages/${encodeURIComponent(messageId)}/stream/${encodeURIComponent(streamId)}?${params}`, {
      method: 'PUT',
    });
  }
}

export default new MessagesAPI();
